import { Component, Input, input, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { Subject, takeUntil } from 'rxjs';
import { OrderManagerService } from '../../services/order-manager/order-manager.service';
import { eBusinessSearchCriteriaType, eBusinessSearchCriteriaTypeString } from '../../enums';
import { Province } from '../../interfaces/province';
import { SearchJurisdiction } from 'projects/reg-hub-common/src/public-api';
import { SearchJurisdictionsComponent } from '../search-jurisdictions/search-jurisdictions.component';
import { MatDialog } from '@angular/material/dialog';
import { Utilities } from '../../utilities';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-order-business-search-criteria',
    templateUrl: './order-business-search-criteria.component.html',
    styleUrls: ['./order-business-search-criteria.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderBusinessSearchCriteriaComponent implements OnInit, OnDestroy {
  private readonly transloco = inject(TranslocoService);
  @Input() isAdmin: boolean = false;
  order!: Order;

  private onDestroy$ = new Subject<void>();

  constructor(private orderManager: OrderManagerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.orderManager.currentOrder
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(order => this.order = order);
  }

  isNameSearch(): boolean {
    return this.order.businessSearchCriteria!.businessSearchCriteriaTypeID == eBusinessSearchCriteriaType.Name ||
      this.order.businessSearchCriteria!.businessSearchCriteriaTypeID.toString() == eBusinessSearchCriteriaTypeString.Name;
  }

  isNumberSearch() {
    return this.order.businessSearchCriteria!.businessSearchCriteriaTypeID == eBusinessSearchCriteriaType.Number ||
      this.order.businessSearchCriteria!.businessSearchCriteriaTypeID.toString() == eBusinessSearchCriteriaTypeString.Number;
  }

  isUSSearch() {
    return this.order.country == "US";
  }

  getSearchType(): string {
    return this.isNameSearch() ? eBusinessSearchCriteriaTypeString.Name : eBusinessSearchCriteriaTypeString.Number;
  }

  getJurisdictionLabel(jurisdiction: string): string {
    var province = Utilities.provinces.find(p => p.value === jurisdiction);
    if (!province) {
      province = Utilities.usStates.find(p => p.value === jurisdiction);
    }
    return province ? province.viewValue : this.transloco.translate('common.labels.unknownJurisdiction');
  }

  getJurisdictionLabels(jurisdictions: SearchJurisdiction[] | undefined): string[] {
    if(jurisdictions === undefined) {
      jurisdictions = [];
    }

    return jurisdictions
      .filter(j => j.jurisdiction !== '_M')
      .map(j => this.getJurisdictionLabel(j.jurisdiction));
  }

  openJurisdictionsDialog() {
    if (this.isAdmin) {
        this.dialog.open(SearchJurisdictionsComponent, { data: this.order, minWidth: '800px' });
    }
  }

  shouldShowSearchParameters(): boolean {
    return this.order.country != "US"
        && this.order.businessSearchCriteria != null
        && this.order.searchParameters?.searchJurisdictions != null
  }
  
  ngOnDestroy(): void {
      // Signal all subscriptions to complete
      this.onDestroy$.next();
      this.onDestroy$.complete();
  }
}
